export const PANEL_STATUS = {
  COMPLETE: 'COMPLETE',
  INCOMPLETE: 'INCOMPLETE',
} as const;

export type PanelStatus = (typeof PANEL_STATUS)[keyof typeof PANEL_STATUS];
